import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  createUserItem,
  getAllUserItems,
  getDataForEdit,
  updateUserItem,
  deleteUserItem,
} from "../../store/User/UserApi";
import { getAllFactoryItems } from "../../store/AppLevelApi/AppLevelApi";
import { userSliceAction } from "../../store/User/UserSlice";
import { headTitle } from "../../utility/GetTableListName";
import MainComponent from "../../components/Base/MainComponent";
//importing constant form option to create form input
import { FormOptionsUser } from "../../ConstantData/FormOptions";
//importing inital form data to store value state
import { InitialUserFormData } from "../../ConstantData/InitialData";
import { ErrorUserFormData } from "../../ConstantData/ErrorOption";
function User() {
  const dispatch = useDispatch();
  useEffect(() => {
    // dispatch(getAllUserItems());
    // dispatch(getAllFactoryItems());
  }, []);
  const isSuccess = useSelector((state) => state.applevel.isSuccess);

  const userList = useSelector((state) => state.user.userList); //store user list
  const InitialFormDataStore = useSelector((state) => state.user.initialData);
  const userEditData = useSelector((state) => state.user.dataEdit);
  const factoryList = useSelector((state) => state.applevel.factoryList);
  let userFormError = useSelector((state) => state.user.errorData);
  let isError = useSelector((state) => state.user.isError);

  userFormError = { ...ErrorUserFormData, ...userFormError };
  let newFormOptionsUser = JSON.parse(JSON.stringify(FormOptionsUser));

  if (factoryList.length > 0) {
    //to chage factory option coming from server
    newFormOptionsUser = FormOptionsUser.map((item) => {
      if (item?.labelName === "Factory") {
        item.options = factoryList;
      }
      return item;
    });
  }

  //function to get list heading
  const headTitleLabel = headTitle(FormOptionsUser, [
    "Name",
    "Role",
    "E-mail",
    "Factory",
  ]); //array is filed that is included in list heading

  return (
    <MainComponent
      InitialFormData={InitialUserFormData}
      createFun={createUserItem} //create function coming from store
      updateFun={updateUserItem} //update function coming from store
      getDataForEdit={getDataForEdit} //edit function coming from store
      delteFun={deleteUserItem}
      FormOptions={newFormOptionsUser}
      OptionName="Create User"
      OptionNameList="User"
      generalList={userList}
      headTitle={headTitleLabel}
      EditData={userEditData}
      generalModuleList={factoryList} //list to add different module
      ErrorData={userFormError}
      isError={isError}
      InitialFormDataStore={InitialFormDataStore}
      setErrorData={userSliceAction.setErrorData}
      isNotDeleteBtn={false}
      isSuccess={isSuccess}
    />
  );
}

export default User;
